import Plot from "react-plotly.js";
import React from "react";

const FactorHeatmap = ({ factorMatches }) => {
  const components = Object.keys(factorMatches).filter(key => key.startsWith('Component_') && !key.includes('p_value'));
  const factors = Object.keys(factorMatches.Component_1);

  const getOpacity = (pValue) => {
    return 1 - pValue; // Linear scale from 1 (p=0) to 0 (p=1)
  };

  const formatFactor = (factor) => {
    return factor.replace('^', '').toUpperCase();
  };

  const formatComponent = (component, index) => {
    return `C-${index + 1}`;
  };

  const zScores = components.map(component =>
    factors.map(factor => factorMatches[component][factor])
  );

  const zPValues = components.map(component =>
    factors.map(factor => factorMatches[`${component}_p_value`][factor])
  );

  const opacities = zPValues.map(row => row.map(getOpacity));

  return (
    <Plot
      data={[
        {
          z: zScores,
          x: factors.map(formatFactor),
          y: components.map(formatComponent),
          type: 'heatmap',
          colorscale: [
            [0, 'rgb(0, 55, 109)'],       // Dark blue for negative values
            [0.5, 'rgb(244, 251, 254)'],   // Light gray for neutral (close to 0)
            [1, 'rgb(0, 190, 255)']        // Light cyan for positive values
          ],
          zmin: -1,
          zmax: 1,
          hovertemplate: 'Factor: %{x}<br>Component: %{y}<br>Score: %{z:.2%}<extra></extra>',
          text: zScores.map(row => row.map(value => `${(value * 100).toFixed(1)}%`)),
          texttemplate: '%{text}',
          textfont: {
            family: 'var(--font-family)',
            size: 10, // Smaller font size for readability
            color: 'black',
            weight: '400' // Make text bold to enhance visibility
          },
         colorbar: {
            outlinewidth: 1,   // Remove the original border from the colorbar
           outlinecolor: '#ddd'
          }
        }
      ]}
      layout={{
        xaxis: {
          side: 'top',
          tickfont: {
            family: 'var(--font-family)',
            size: 10,
            color: 'black',
            weight: '400',
          },
          tickangle: 0, // Rotate labels for better spacing
        },
        yaxis: {
          tickfont: {
            family: 'var(--font-family)',
            size: 10,
            color: 'black',
            weight: '400',
          }
        },
        margin: {
          l: 50, // Increase for better y-axis label visibility
          r: 20,
          b: 0,
          t: 25,
          pad: 5
        },
        font: {
          family: 'var(--font-family)',
          size: 10,
        },
        paper_bgcolor: 'rgba(0,0,0,0)',
        plot_bgcolor: 'rgba(0,0,0,0)',
        autosize: true,
      }}
      config={{
        displayModeBar: false,
        responsive: true,
      }}
    />
  );
};

export default FactorHeatmap;